import { useEffect, useRef, useState } from 'react';

const MENU_URL = 'https://coreassets.indzs.com/files/indzs/nine-dot-menu.html';
const STORAGE_KEY = 'nine_dot_menu_html';

const INDZS_APPS = [
  {
    name: 'Search',
    url: 'http://localhost:8003/api/auth/accounts/redirect',
    color: '#df7016',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
    ),
  },
  {
    name: 'Drive',
    url: 'http://localhost:8001/auth/accounts/redirect',
    color: '#3b82f6',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="8" x="2" y="14" rx="2"/><path d="M6 18h.01"/><path d="M10 18h.01"/><rect width="20" height="8" x="2" y="2" rx="2"/><path d="M6 6h.01"/><path d="M10 6h.01"/></svg>
    ),
  },
  {
    name: 'Kujanam',
    url: 'http://localhost:8002/auth/accounts/redirect',
    color: '#10b981',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
    ),
  },
  {
    name: 'Account',
    url: 'http://localhost:3000',
    color: '#8b5cf6',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
    ),
  },
];

export function NineDotMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);

  const makeResponsiveMenu = (html: string) =>
    html.replace(
      '</style>',
      `.indzs-menu-card {
          width: 100% !important;
          max-width: none !important;
        }
        .indzs-menu-card-inner {
          width: 100% !important;
          max-height: 480px !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
        }
        </style>`,
    );

  const toggleMenu = async (e: React.MouseEvent) => {
    e.stopPropagation();

    if (isOpen) {
      setIsOpen(false);
      return;
    }

    const cachedHtml = sessionStorage.getItem(STORAGE_KEY);
    if (cachedHtml) {
      setHtmlContent(makeResponsiveMenu(cachedHtml));
      setIsOpen(true);
      return;
    }

    setIsLoading(true);
    setIsOpen(true);

    try {
      const res = await fetch(MENU_URL);
      if (!res.ok) throw new Error('Failed to load menu HTML');
      const html = await res.text();
      sessionStorage.setItem(STORAGE_KEY, html);
      setHtmlContent(makeResponsiveMenu(html));
    } catch (err) {
      console.warn('Could not fetch remote menu, using fallback grid', err);
      setHtmlContent('');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        isOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="relative">
      <div
        ref={buttonRef}
        title="INDZS Apps"
        onClick={toggleMenu}
        className="menu-toggle cursor-pointer rounded-full p-2 text-foreground/70 transition-all hover:bg-hover hover:text-foreground flex items-center justify-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="currentColor"
        >
          <path d="M243.6-168q-31.1 0-53.35-22.15T168-243.4q0-31.1 22.15-53.35T243.4-319q31.1 0 53.35 22.15T319-243.6q0 31.1-22.15 53.35T243.6-168Zm236.5 0q-31.1 0-53.35-22.15T404.5-243.4q0-31.1 22.15-53.35T479.9-319q31.1 0 53.35 22.15t22.25 53.25q0 31.1-22.15 53.35T480.1-168Zm236.5 0q-31.1 0-53.35-22.15T641-243.4q0-31.1 22.15-53.35T716.4-319q31.1 0 53.35 22.15T792-243.6q0 31.1-22.15 53.35T716.6-168Zm-473-236.5q-31.1 0-53.35-22.15T168-479.9q0-31.1 22.15-53.35t53.25-22.25q31.1 0 53.35 22.15T319-480.1q0 31.1-22.15 53.35T243.6-404.5Zm236.5 0q-31.1 0-53.35-22.15T404.5-479.9q0-31.1 22.15-53.35t53.25-22.25q31.1 0 53.35 22.15t22.25 53.25q0 31.1-22.15 53.35T480.1-404.5Zm236.5 0q-31.1 0-53.35-22.15T641-479.9q0-31.1 22.15-53.35t53.25-22.25q31.1 0 53.35 22.15T792-480.1q0 31.1-22.15 53.35T716.6-404.5ZM243.6-641q-31.1 0-53.35-22.15T168-716.4q0-31.1 22.15-53.35T243.4-792q31.1 0 53.35 22.15T319-716.6q0 31.1-22.15 53.35T243.6-641Zm236.5 0q-31.1 0-53.35-22.15T404.5-716.4q0-31.1 22.15-53.35T479.9-792q31.1 0 53.35 22.15t22.25 53.25q0 31.1-22.15 53.35T480.1-641Zm236.5 0q-31.1 0-53.35-22.15T641-716.4q0-31.1 22.15-53.35T716.4-792q31.1 0 53.35 22.15T792-716.6q0 31.1-22.15 53.35T716.6-641Z" />
        </svg>
      </div>

      {isOpen && (
        <div
          ref={menuRef}
          className="fixed left-1/2 -translate-x-1/2 top-[55px] z-[9999] transition-all duration-200 shadow-2xl rounded-3xl border border-border overflow-hidden w-[calc(100vw-8px)] max-w-[380px] min-w-0 md:absolute md:left-auto md:right-0 md:translate-x-0 md:top-[48px]"
          style={{
            width: 'min(380px, calc(100vw - 8px))',
            maxWidth: 'calc(100vw - 8px)',
            minWidth: 0,
            height: '505px',
            maxHeight: 'calc(100vh - 70px)',
            padding: 0,
            borderRadius: '24px',
            boxShadow: '0 12px 36px rgba(0, 0, 0, 0.15)',
          }}
        >
          {isLoading ? (
            <div className="flex flex-col items-center justify-center p-6 gap-2">
              <svg className="animate-spin h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span className="text-xs text-muted-foreground font-medium uppercase tracking-widest">Loading...</span>
            </div>
          ) : htmlContent ? (
            <div
              className="w-full h-full text-foreground"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          ) : (
            <div>
              <div className="mb-3 px-2 text-[11px] font-bold uppercase tracking-wider opacity-60">
                INDZS Apps
              </div>
              <div className="grid grid-cols-2 gap-2">
                {INDZS_APPS.map((app) => (
                  <a
                    key={app.name}
                    href={app.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex flex-col items-center justify-center rounded-2xl p-3 cursor-pointer border border-transparent transition-all hover:bg-hover hover:border-border"
                  >
                    <div
                      className="mb-1.5 flex h-10 w-10 items-center justify-center rounded-xl shadow-md transition-transform group-hover:scale-110"
                      style={{
                        backgroundColor: `${app.color}25`,
                        color: app.color,
                      }}
                    >
                      {app.icon}
                    </div>
                    <span className="text-xs font-semibold">{app.name}</span>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
